import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
import * as contactMdls from '../models/ServiceContactModel';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface ServiceContactEntryProcessing { type: 'SERVICECONTRACTENTRY_PROCESSING', processing: boolean }
export interface ServiceContactEntryError { type: 'SERVICECONTRACTENTRY_ERROR', error: string }
export interface ServiceContactEntrySuccess { type: 'SERVICECONTRACTENTRY_SUCCESS' }
export interface ServiceContactEntryReset { type: 'SERVICECONTRACTENTRY_RESET' }

export type KnownAction = ServiceContactEntryProcessing | ServiceContactEntryError | ServiceContactEntrySuccess | ServiceContactEntryReset ;

export const actionCreators = {
    updateCustomer: (newContact: contactMdls.ServiceContactModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;

        newContact.serviceMaster.id = sessionState.SelectedSM.id;
        newContact.companyCode = sessionState.SelectedAR.companyCode;


        dispatch({ type: 'SERVICECONTRACTENTRY_PROCESSING', processing: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/ServiceContact',
            {
                method: 'POST',
                body: JSON.stringify(newContact),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {

                if (container.success) {
                    const data: contactMdls.ServiceContactModel = container.data;
                    //Do something with response             
                    dispatch({ type: 'SERVICECONTRACTENTRY_SUCCESS' });
                } else {
                    dispatch({
                        type: 'SERVICECONTRACTENTRY_ERROR', error: container.errorInfo.message
                    });
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'SERVICECONTRACTENTRY_ERROR', error: err.message
                });
                sawinFunc.log({ message: err.message, logType: LogTypes.Error, clientMessage: '' });
            });
    },
    resetState: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: "SERVICECONTRACTENTRY_RESET" });    
    }
};

export const reducer: Reducer<contactMdls.ServiceContactModel> = (state: contactMdls.ServiceContactModel | undefined, incomingAction: Action): contactMdls.ServiceContactModel => {

    if (state === undefined) {
        return { ...contactMdls.initialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'SERVICECONTRACTENTRY_PROCESSING':
            return { ...state, processing: (action as ServiceContactEntryProcessing).processing }
        case 'SERVICECONTRACTENTRY_ERROR':
            return { ...state, processing: false, error: (action as ServiceContactEntryError).error }
        case 'SERVICECONTRACTENTRY_SUCCESS':
            return { ...state, processing: false, error: '', success: 'Y' }
        case 'SERVICECONTRACTENTRY_RESET':
            return { ...state, ...contactMdls.initialState }
        default:
            return state;
    }
};
